import { Component } from 'react';
import PropTypes from 'prop-types';
import { AppInsights } from 'applicationinsights-js';
import away from 'away';

export default class MCaseViewTracker extends Component {
  constructor() {
    super();
    this.viewSwitch = this.viewSwitch.bind(this);
    this.resetTimers = this.resetTimers.bind(this);
  }

  UNSAFE_componentWillMount() {
    let timer = away(30000);
    let self = this;
    timer.on('idle', function () {
      self.startIdleTimer = Date.now();
    });
    timer.on('active', function () {
      self.idleTimeInMs += Date.now() - self.startIdleTimer;
    });
    this.resetTimers();
  }

  resetTimers() {
    this.componentWillMountTimestamp = Date.now();
    this.idleTimeInMs = 0;
  }

  viewSwitch() {
    if (!this.componentWillMountTimestamp) {
      throw "ComponentWillMountTimestamp was not initialized. Check if super.componentWillMount() was called";
    }
    let profile = {};
    try {
      profile = this.props.profile;
    } catch (ex) {
      // big error
    }
    let measurements = {
      'Engaged': (Date.now() - this.componentWillMountTimestamp - (this.idleTimeInMs ? this.idleTimeInMs : 0)) / 1000,
      'Elapsed': (Date.now() - this.componentWillMountTimestamp) / 1000,
      'Idle': (this.idleTimeInMs ? this.idleTimeInMs / 1000 : 0)
    };
    let properties = {
      'View': 'MCaseView',
      'ControlNumber': this.props.controlNumber,
      'Username': profile.username,
      'UserId': profile.internetUserId
    };
    AppInsights.trackEvent("MCaseView: Time Spent Tracker", properties, measurements);
    this.resetTimers();
  }

  render() {
    return false;
  }
}

MCaseViewTracker.propTypes = {
  formId: PropTypes.string,
  formStatus: PropTypes.string,
  controlNumber: PropTypes.number,
  location: PropTypes.object,
  profile: PropTypes.object,
};
